/* eslint-disable @typescript-eslint/naming-convention */
export interface IAnalyticsPagePayload {
  controller: string;
  location_hash: string;
  path: string;
  gtmhub_application_name: string;
  gtmhub_path: string;
}

export interface IRecommendationArgs {
  isUseful: boolean;
}

export enum Flavor {
  PASSIVE = "Passive",
  ACTIVE = "Active",
  SMART_DEFAULT = "Smart Default",
}

export const recommendation = "Recommendation Given";
